<script setup>
import { defineProps, computed } from "vue";
import { useDesignLabStore } from "../DesignLabStore.js"

const designLabStore = useDesignLabStore();

// props
const props = defineProps({
  title:       String, // 標題
  desktopMode: Boolean,
});

const disableBackBtn = computed(() => {
  let toDisable = false;
  if (designLabStore.currentPathIdx == 0) toDisable = true;
  if (designLabStore.design.is_published) toDisable = true;
  
  return toDisable
})

const disableCloseBtn = computed(() => {
  let toDisable = false;
  if (designLabStore.isShareInfoMode) toDisable = true;
  if (designLabStore.design.is_published) toDisable = true;
  
  return toDisable
})

</script>

<template>
  <div class="mk-setup-card" :class="{ 'mk-setup-card--has-action': $slots.action }">
    <!-- header -->
    <div class="mk-setup-card__header">
      <!-- previous icon -->
      <div class="mk-setup-card__header__icon" title="前一步">
        <svg 
          @click  = "designLabStore.goToPreviousSetup()"
          :class  = "{'d-none': disableBackBtn}"
          xmlns   = "http://www.w3.org/2000/svg"
          viewBox = "0 0 11.4 20.1"
        >
          <path
            d="M10 20.1c-.4 0-.7-.1-1-.4L.4 11c-.3-.2-.4-.6-.4-1s.1-.7.4-1L9 .4c.5-.5 1.4-.5 2 0s.5 1.4 0 2L3.4 10l7.7 7.7c.5.5.5 1.4 0 2-.3.3-.7.4-1.1.4z">
          </path>
        </svg>
      </div>

      <!-- title -->
      <div class="mk-setup-card__header__title">{{ props.title }}</div>

      <!-- inactive icon -->
      <div 
        class  = "mk-setup-card__header__icon"
        title  = "關閉"
        @click = "designLabStore.inactiveSetup()"
      >
        <svg 
          :class  = "{'d-none': disableCloseBtn}"
          xmlns   = "http://www.w3.org/2000/svg"
          viewBox = "0 0 16 16"
        >
          <g id="Product-Summary---Deskop" stroke="none" stroke-width="1" fill-rule="evenodd">
            <g id="LBP---Product-Summary---Default" transform="translate(-581 -1193)">
              <path
                d="M597.878 1199.97h-8.03v-8.03a.94.94 0 0 0-1.879 0v8.03h-8.03a.94.94 0 0 0 0 1.878h8.03v8.03a.94.94 0 0 0 1.878 0v-8.03h8.03a.94.94 0 0 0 0-1.879Z"
                id="Shape-Copy" transform="rotate(45 588.908 1200.908)"></path>
            </g>
          </g>
        </svg>
      </div>
  </div>

  <!-- content -->
  <div class="mk-setup-card__content">
    <div class="mk-spinner m-auto" v-if="designLabStore.loading"></div>
    <slot name="content" v-if="!designLabStore.loading"></slot>
  </div>

  <div class="mk-setup-card__action" v-if="$slots.action">
    <slot name="action"></slot>
  </div>
</div></template>